import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";
import { Cookie } from "lucide-react";

const CONSENT_KEY = "cap-malaisie-cookie-consent";

export const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(CONSENT_KEY);
      if (!stored) {
        setVisible(true);
      } else if (stored === "accepted") {
        enableTracking();
      }
    } catch (e) {
      // ignore storage errors
    }
  }, []);

  const enableTracking = () => {
    if (window.posthog && typeof window.posthog.opt_in_capturing === "function") {
      window.posthog.opt_in_capturing();
    }
  };

  const accept = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "accepted");
    } catch (e) {}
    enableTracking();
    setVisible(false);
  };

  const decline = () => {
    try {
      localStorage.setItem(CONSENT_KEY, "declined");
    } catch (e) {}
    if (window.posthog && typeof window.posthog.opt_out_capturing === "function") {
      window.posthog.opt_out_capturing();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[100] bg-card border-t border-border shadow-[0_-4px_20px_rgba(36,27,20,0.10)] p-4 md:p-5"
      role="banner"
      aria-label={t.cookieConsent.ariaLabel}
    >
      <div className="container-page flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-5 w-5 text-accent mt-0.5 shrink-0" />
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t.cookieConsent.message}
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            variant="outline"
            size="sm"
            onClick={decline}
            className="rounded-xl border-border bg-card hover:bg-secondary text-sm"
          >
            {t.cookieConsent.decline}
          </Button>
          <Button
            size="sm"
            onClick={accept}
            className="rounded-xl text-sm"
          >
            {t.cookieConsent.accept}
          </Button>
        </div>
      </div>
    </div>
  );
};
